import { Directive, OnInit } from '@angular/core';
import { SortField } from '../../classes/sortfield';

@Directive()
export abstract class SortComponent implements OnInit {
  sortFields: SortField[];

  ngOnInit(): void {
    this.setApplicableSortFields();
  }

  setApplicableSortFields() {
    const sortFields = this.getSortFields();

    const activeSortFieldKey = this.getActiveSortFieldKey().split('|')[0];
    const activeSortFieldDirection = this.getActiveSortFieldKey().split('|')[1];

    const activeSortField: SortField = sortFields.find(sortField => sortField.key === activeSortFieldKey);

    // Adds an extra desc or asc option for the currently
    // active SortField, so that the user can easily switch between desc/asc.
    if (activeSortField) {
      activeSortField.showOrder = true;
      activeSortField.asc = activeSortFieldDirection !== 'DESC';
      sortFields.push(new SortField(
          activeSortField.key,
          activeSortField.name,
          !activeSortField.asc,
          true
        ));
    }

    // Makes sure the sort fields which show an order icon (so the 'active asc/desc filters')
    // are placed at top of the select.
    sortFields.sort((field1: SortField, field2: SortField) => {
      if (field1.showOrder && !field2.showOrder) {
        return -1;
      }

      if (!field1.showOrder && field2.showOrder) {
        return 1;
      }

      return 0;
    });

    this.sortFields = sortFields;
  }

  abstract getActiveSortFieldKey(): string;

  abstract getSortFields(): SortField[];
}
